import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export function VerticalBar({
  displayNumberOnYAxis = true,
  callBackFunctionForYGrid = function (value) {
    if (value >= 1000) {
      return value / 1000 + "K";
    }
    return value;
  },
  displayLegends = true,
  yGrid = true,
  stepSize = 250000,
  legendsPosition = "bottom",
  label = ["JAN", "FEB", "MAR", "APR"],
  barChartData = [
    {
      label: "Assets",
      data: label.map(() => 0),
      backgroundColor: "#1bbb6b",
      borderRadius: 4,
      borderSkipped: false,
    },
    {
      label: "Liabilities",
      data: label.map(() => 0),
      backgroundColor: "#FC3C42",
      borderRadius: 4,
      borderSkipped: false,
    },
    {
      label: "Net Worth",
      data: label.map(() => 0),
      backgroundColor: "#F7A64F",
      borderRadius: 4,
      borderSkipped: false,
    },
  ],
  legendSize = 10,
}) {
  const labels = label;

  const options = {
    plugins: {
      legend: {
        position: legendsPosition,
        display: displayLegends,
        labels: {
          usePointStyle: true,
          pointStyle: "circle",

          font: {
            size: legendSize,
          },
        },
      },
      title: {
        display: false,
      },
    },

    responsive: true,

    scales: {
      x: {
        // grid: {
        //   borderDash: [4, 4], // Makes the grid lines dotted
        // },
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
        display: displayNumberOnYAxis,

        ticks: {
          stepSize: stepSize,
          callback: callBackFunctionForYGrid,
        },
        grid: {
          display: yGrid,
        },
      },
    },
  };

  const data = {
    labels,
    datasets: barChartData,
  };
  return <Bar options={options} data={data} />;
}
